import { noop } from 'lodash'
import React from 'react'
import { LibraryUsageRequestProps } from '.'
import { LibraryUsageDownloader } from './library-usage-downloader'
import { MenuItem } from '@contrast-security-inc/design-system-popovers'
import { useIntl } from 'react-intl'
import { useLibraryUsageGridContext } from '../../../library-usage-grid/library-usage-context'

interface Props
  extends Omit<LibraryUsageRequestProps, 'filters' | 'sortingOrder'> {
  readonly disabled?: boolean
}

export function LibraryUsageExportAction({
  organizationID,
  applicationID,
  libraryHash
}: Props) {
  const { formatMessage } = useIntl()
  const { sortingOrder, searchText } = useLibraryUsageGridContext()

  return (
    <LibraryUsageDownloader>
      {({ download }) => (
        <span
          onClick={() => {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            download({
              organizationID,
              applicationID,
              libraryHash,
              filters: { filterText: searchText },
              sortingOrder
            })
          }}
        >
          <MenuItem onClick={noop} testId="library-usage-export-action">
            {formatMessage({ id: 'title_export_usage' })}
          </MenuItem>
        </span>
      )}
    </LibraryUsageDownloader>
  )
}
